var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};



//////////////////
// WEBPACK FOOTER
// /codebuild/output/src3659550778/src/~/core-js/library/modules/_uid.js
// module id = yH18
// module chunks = 6